import { render, staticRenderFns } from "./applicant-name.vue?vue&type=template&id=770e4a4c"
import script from "./applicant-name.vue?vue&type=script&lang=js"
export * from "./applicant-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports